import { useStates } from '@uplift/queries';
import { SettingsAddressForm } from '@uplift/ui-v2';


export const AddressForm = () => {
  const { states } = useStates();

  if (!states?.length) return null;

  return <SettingsAddressForm states={states} />;
};
